import React, { useEffect } from 'react';
import { Title } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Grid, Paper,
  CardActionArea, Chip, Divider,
} from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { getManualEntriesByCategory } from '../index';
import { track, EVENTS } from '../../lib/analytics';

const ManualIndex: React.FC = () => {
  const navigate = useNavigate();
  const entriesByCategory = getManualEntriesByCategory();

  useEffect(() => {
    track(EVENTS.MANUAL_OPENED);
  }, []);

  return (
    <Card>
      <Title title="Manual do Sistema" />
      <CardContent>
        <Box display="flex" alignItems="center" gap={2} mb={3}>
          <MenuBookIcon sx={{ fontSize: 40, color: '#7869DF' }} />
          <Box>
            <Typography variant="h5" fontWeight={700}>Manual do Sistema</Typography>
            <Typography variant="body2" color="text.secondary">
              Guias e tutoriais para utilizar as funcionalidades do painel
            </Typography>
          </Box>
        </Box>

        {Object.entries(entriesByCategory).map(([category, entries]) => (
          <Box key={category} mb={4}>
            <Typography variant="h6" fontWeight={600} mb={2}>{category}</Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              {entries.map(entry => (
                <Grid key={entry.slug} size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper elevation={2} sx={{ height: '100%' }}>
                    <CardActionArea
                      onClick={() => navigate(`/manual/${entry.slug}`)}
                      sx={{
                        p: 2.5,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Chip
                        label={category}
                        size="small"
                        sx={{ mb: 1, bgcolor: '#7869DF', color: '#fff' }}
                      />
                      <Typography variant="subtitle1" fontWeight={600}>
                        {entry.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" mt={1}>
                        {entry.description}
                      </Typography>
                    </CardActionArea>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default ManualIndex;
